import React, { useContext } from 'react';

import Header from '@templates/header';

import {
  Button,
  Link,
  Divider,
  Box,
  Typography,
} from 'vindi-ds-components';

import { CustomerPermissionsContext } from '@contexts/customer_permissions_context';
import { PrPlus } from 'vindi-ds-icons/pr';

function HeaderCustomerList({ description, isMobile }) {
  const { canCreateCustomer, canShowCustomersImport } = useContext(CustomerPermissionsContext);

  return (
    <>
      {isMobile ? (
        <Box
          display='grid'
          gridTemplateColumns={{ xs: '1fr 1fr', sm: '1.25fr 1fr' }}
          mb={4}
        >
          <Typography variant='h5' component='h1'>
            Clientes
          </Typography>

          <Button
            href='customers/new'
            startIcon={<PrPlus />}
            size='small'
            disabled={!canCreateCustomer}
          >
            Novo cliente
          </Button>
        </Box>
      ) : (
        <Header.Default
          links={[<Link href='/admin/dashboard'>Início</Link>]}
          title='Clientes'
        />
      )}

      <Divider />

      <Box display='flex' alignItems='center' justifyContent='space-between' mt={3}>
        <Box>
          <Typography>{description}</Typography>
        </Box>

        {!isMobile && (
          <Box display='flex' flexWrap='wrap' justifyContent='flex-end' gap={2}>
            <Button
              href='/admin/customers/imports'
              startIcon={<PrPlus />}
              size='small'
              variant='secondary'
              disabled={!canShowCustomersImport}
            >
              Importação em massa
            </Button>

            <Button
              href='customers/new'
              startIcon={<PrPlus />}
              size='small'
              disabled={!canCreateCustomer}
            >
              Novo cliente
            </Button>
          </Box>
        )}
      </Box>
    </>
  );
}

export default HeaderCustomerList;
